import { render, staticRenderFns } from "./Store.vue?vue&type=template&id=efd477f2&scoped=true&"
import script from "./Store.vue?vue&type=script&lang=ts&"
export * from "./Store.vue?vue&type=script&lang=ts&"
import style0 from "./Store.vue?vue&type=style&index=0&id=efd477f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd477f2",
  null
  
)

export default component.exports